import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { PublicSharedModule } from '../../../public/shared/modules/public-shared.module';
import { ResetUserPage } from './reset-user.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PublicSharedModule,
    TranslateModule,
  ],
  declarations: [
    ResetUserPage
  ]
})
export class ResetUserPageModule {}
